import { z } from 'zod';
import { ImportanceEnum } from '../../../enums/importance';

export const PersonalizedCommunicationTranslationValidatorSchema = z.object({
  lang: z.string(),
  introHtml: z.string().optional().nullable(),
  footerHtml: z.string().optional().nullable(),
  subject: z.string().max(255).optional().nullable(),
});

export const PersonalizedCommunicationValidatorSchema = z.object({
  status: z.enum(['PENDING', 'SENDING', 'SENT']).optional(),
  sentAt: z.string().optional().nullable(),
  sentLocale: z.string().optional().nullable(),
  translations: z.array(PersonalizedCommunicationTranslationValidatorSchema),
});

export const WaitingListInvitationValidatorSchema = z.object({
  numberOfSeats: z.number(),
  importance: z.enum(ImportanceEnum),
  order: z.number().nullable().optional(),
  numberOfNonAllocatedSeats: z.number().optional(),
  invitationReason: z.string().optional(),
  specialGuestId: z.string().optional(),
  personalizedCommunication: PersonalizedCommunicationValidatorSchema
    .optional()
    .nullable(),
});

export type WaitingListInvitationValidator = z.infer<
  typeof WaitingListInvitationValidatorSchema
>;

export const InvitationSwapValidatorSchema = z
  .object({
    waitingListInvitationId: z.string(),
    order: z.number(),
  })
  .array();

export type InvitationSwapValidator = z.infer<
  typeof InvitationSwapValidatorSchema
>;

export type FGOInvitationRejectBody = {
  rejectionReason?: string | null;
};
